'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _sizes = require('HubStyleTokens/sizes');

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _memoizeOne = require('react-utils/memoizeOne');

var _memoizeOne2 = _interopRequireDefault(_memoizeOne);

var _UIButton = require('../../button/UIButton');

var _UIButton2 = _interopRequireDefault(_UIButton);

var _UIClickable = require('../../button/UIClickable');

var _UIClickable2 = _interopRequireDefault(_UIClickable);

var _Tether = require('../../constants/Tether');

var _Functions = require('../../core/Functions');

var _SyntheticEvent = require('../../core/SyntheticEvent');

var _SyntheticEvent2 = _interopRequireDefault(_SyntheticEvent);

var _ShareButton = require('../../decorators/ShareButton');

var _ShareButton2 = _interopRequireDefault(_ShareButton);

var _UIIcon = require('../../icon/UIIcon');

var _UIIcon2 = _interopRequireDefault(_UIIcon);

var _focusStylesListener = require('../../listeners/focusStylesListener');

var _PlacementConstants = require('../../tooltip/PlacementConstants');

var _UIControlledPopover = require('../../tooltip/UIControlledPopover');

var _UIControlledPopover2 = _interopRequireDefault(_UIControlledPopover);

var _UIPopoverArrow = require('../../tooltip/UIPopoverArrow');

var _UIPopoverArrow2 = _interopRequireDefault(_UIPopoverArrow);

var _customRenderer = require('../../utils/propTypes/customRenderer');

var CustomRenderer = _interopRequireWildcard(_customRenderer);

var _decorators = require('../../utils/propTypes/decorators');

var _iconName = require('../../utils/propTypes/iconName');

var _refObject = require('../../utils/propTypes/refObject');

var _refObject2 = _interopRequireDefault(_refObject);

var _tshirtSize = require('../../utils/propTypes/tshirtSize');

var _Timers = require('../../utils/Timers');

var _underscore = require('../../utils/underscore');

var _UIDropdownCaret = require('../UIDropdownCaret');

var _UIDropdownCaret2 = _interopRequireDefault(_UIDropdownCaret);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var getArrowSize = function getArrowSize(buttonUse) {
  if (buttonUse.match(/link|transparent/)) {
    return 'medium';
  }
  return 'none';
};

var getPlacement = function getPlacement(placement, computedArrowSize) {
  if (placement) {
    return placement;
  }
  // Center if we have an arrow, otherwise flush left against the target
  if (computedArrowSize !== 'none') {
    return 'bottom';
  }
  return 'bottom right';
};

var getDistanceAdjustment = function getDistanceAdjustment(buttonSize, buttonUse) {
  if (buttonUse === 'transparent') {
    // Account for invisible padding
    var shorthandSize = (0, _tshirtSize.toShorthandSize)(buttonSize);
    var buttonPaddingY = void 0;
    if (shorthandSize === 'xs') {
      buttonPaddingY = _sizes.BUTTON_XS_PADDING_Y;
    } else if (shorthandSize === 'sm') {
      buttonPaddingY = _sizes.BUTTON_SM_PADDING_Y;
    } else {
      buttonPaddingY = _sizes.BUTTON_DEFAULT_PADDING_Y;
    }
    return -parseInt(buttonPaddingY, 10);
  }
  return 0;
};

var getInsetAdjustment = function getInsetAdjustment(buttonUse, placement, computedArrowSize) {
  if (buttonUse === 'transparent' && placement === 'bottom right' && computedArrowSize === 'none') {
    // Account for invisible padding. Inset adjustments are applied twice
    // (once to the tether attachment, once to the target attachment), so
    // we halve our value here.
    return -parseInt(_sizes.BUTTON_DEFAULT_PADDING_X, 10) / 2;
  }
  return 0;
};

var getButtonClassName = function getButtonClassName(className, multiline, open, readOnly) {
  return (0, _classnames2.default)(className, 'private-button__dropdown-opener', 'uiDropdown__button', {
    'private-button__dropdown-opener--multiline': multiline,
    'private-button__dropdown-opener--open': open,
    // a 'readonly' <button> doesn't make sense, so apply class for styling here
    'private-button--readonly': readOnly
  });
};

var getStyle = function getStyle(menuWidth, controlWidth) {
  return {
    width: menuWidth || controlWidth,
    minWidth: menuWidth === 'auto' ? controlWidth : null
  };
};

var renderButtonLabel = function renderButtonLabel(buttonText, iconName, readOnly) {
  var buttonClassNames = (0, _classnames2.default)('private-dropdown__button-label', 'uiDropdown__buttonLabel', {
    'private-dropdown__button-label--no-icon': !iconName && !buttonText || readOnly
  });
  var icon = iconName ? _react2.default.createElement(_UIIcon2.default, { className: 'private-dropdown__icon', name: iconName }) : null;
  return _react2.default.createElement(
    'span',
    { className: buttonClassNames },
    icon,
    buttonText == null || buttonText === '' ? '\u200B' : buttonText
  );
};

var UIAbstractDropdown = function (_Component) {
  _inherits(UIAbstractDropdown, _Component);

  function UIAbstractDropdown(props) {
    _classCallCheck(this, UIAbstractDropdown);

    var _this = _possibleConstructorReturn(this, (UIAbstractDropdown.__proto__ || Object.getPrototypeOf(UIAbstractDropdown)).call(this, props));

    _this.state = {
      controlWidth: 0
    };

    _this.measureControlWidth = function () {
      // Make the menu width match up with the anchor width
      var _this$props = _this.props,
          buttonRef = _this$props.buttonRef,
          open = _this$props.open;

      var controlEl = buttonRef.current;
      if (controlEl && open) {
        var controlWidth = _this.computeControlWidth(controlEl);
        if (controlWidth !== _this.state.controlWidth) {
          _this.setState({
            controlWidth: controlWidth
          });
        }
      }
    };

    _this.hasKeyboardFocus = function () {
      var buttonRef = _this.props.buttonRef;

      var activeElement = document.activeElement;
      var dropdownNode = document.getElementById(_this._contentId);
      if (!activeElement) {
        return false;
      }
      if (activeElement === buttonRef.current) {
        return true;
      } else if (dropdownNode && dropdownNode.contains(activeElement)) {
        return true;
      }
      return false;
    };

    _this.handleButtonClick = function (evt) {
      var _this$props2 = _this.props,
          locked = _this$props2.locked,
          open = _this$props2.open,
          onClick = _this$props2.onClick;

      (0, _Functions.callIfPossible)(onClick, evt);

      if (!locked) {
        var nextOpen = !open;
        _this.setIsOpen(nextOpen);
      }
    };

    _this.shouldCloseOnClick = function (evt) {
      var _this$props3 = _this.props,
          buttonRef = _this$props3.buttonRef,
          shouldCloseOnClick = _this$props3.shouldCloseOnClick;

      // If `shouldCloseOnClick` is provided and returns a non-null value, defer to it

      if (shouldCloseOnClick) {
        var shouldClose = shouldCloseOnClick(evt);
        if (shouldClose != null) return shouldClose;
      }

      var target = evt.target;
      var controlNode = buttonRef.current;
      if (!controlNode) return null;

      // Ignore clicks on any <label> that contain the button
      var parentEl = controlNode;
      while (parentEl.parentElement) {
        parentEl = parentEl.parentElement;
        if (parentEl.tagName === 'LABEL' && parentEl.contains(target)) {
          return false;
        }
      }

      // Ignore clicks on any <label> whose "for" attr points to the button
      var id = controlNode.id;
      if (id) {
        var labelsForControl = document.querySelectorAll('label[for="' + id + '"]');
        for (var i = 0; i < labelsForControl.length; i++) {
          if (labelsForControl[i].contains(target)) {
            return false;
          }
        }
      }

      return null;
    };

    _this.handleWindowResize = function () {
      (0, _Timers.cancelSchedulerCallback)(_this._resizeFrame);
      _this._resizeFrame = (0, _Timers.requestSchedulerCallback)(_this.measureControlWidth);
    };

    _this.handleKeyDown = function (evt) {
      // Handle keydown events from both the button and the dropdown
      var _this$props4 = _this.props,
          onKeyDown = _this$props4.onKeyDown,
          open = _this$props4.open;

      if (open && evt.key === 'Escape') {
        _this.setIsOpen(false);
        evt.stopPropagation();
      }
      (0, _Functions.callIfPossible)(onKeyDown, evt);
    };

    _this.setIsOpen = function (nextOpen) {
      var _this$props5 = _this.props,
          onOpenChange = _this$props5.onOpenChange,
          readOnly = _this$props5.readOnly;

      if (!onOpenChange || readOnly) {
        return;
      }
      onOpenChange((0, _SyntheticEvent2.default)(nextOpen));
    };

    _this.focusOnControl = function () {
      // When focusing, reset the scroll coordinates to negate the browser's scroll behavior
      var buttonRef = _this.props.buttonRef;
      var _document$documentEle = document.documentElement,
          scrollLeft = _document$documentEle.scrollLeft,
          scrollTop = _document$documentEle.scrollTop;

      var controlNode = buttonRef.current;
      if (!controlNode) return;
      controlNode.focus();
      scrollTo(scrollLeft, scrollTop);
    };

    _this.computeControlWidth = function (controlEl) {
      var open = _this.props.open;

      if (!controlEl || !open) {
        return 0;
      }
      var exactWidth = controlEl.getBoundingClientRect().width;
      var roundedWidth = window.chrome ? Math.floor(exactWidth) : exactWidth;
      return roundedWidth - 2; // account for 1px border added by UIPopover
    };

    _this.renderContent = function () {
      var _this$props6 = _this.props,
          children = _this$props6.children,
          Content = _this$props6.Content,
          dropdownClassName = _this$props6.dropdownClassName,
          dropdownContentRef = _this$props6.dropdownContentRef,
          menuWidth = _this$props6.menuWidth,
          minMenuWidth = _this$props6.minMenuWidth;


      var controlWidth = Math.max(_this.state.controlWidth, minMenuWidth);

      return _react2.default.createElement(
        'div',
        {
          className: (0, _classnames2.default)('private-dropdown', 'uiDropdown__dropdown', dropdownClassName),
          id: _this._contentId,
          onKeyDown: _this.handleKeyDown,
          ref: dropdownContentRef,
          role: 'presentation',
          style: _this._getStyle(menuWidth, controlWidth)
        },
        Content ? _react2.default.createElement(Content, null) : children
      );
    };

    _this._buttonId = (0, _underscore.uniqueId)('uiabstractdropdown-button-');
    _this._contentId = (0, _underscore.uniqueId)('uiabstractdropdown-content-');
    _this._getStyle = (0, _memoizeOne2.default)(getStyle);
    _this.popoverRef = _react2.default.createRef();
    return _this;
  }

  _createClass(UIAbstractDropdown, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var open = this.props.open;

      if (open) {
        this.measureControlWidth();
        addEventListener('resize', this.handleWindowResize);
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      var open = this.props.open;

      // ⚠️ This condition prevents infinite loops! ⚠️

      if (prevState.controlWidth === this.state.controlWidth) {
        this.measureControlWidth();
      }

      // If the dropdown was closed via the keyboard, and the focus was within the dropdown, then give
      // keyboard focus to the control.
      if (prevProps.open && !open && this.hasKeyboardFocus() && (0, _focusStylesListener.isPageInKeyboardMode)()) {
        this.focusOnControl();
      }

      if (!prevProps.open && open) {
        addEventListener('resize', this.handleWindowResize);
      } else if (prevProps.open && !open) {
        removeEventListener('resize', this.handleWindowResize);
        (0, _Timers.cancelSchedulerCallback)(this._resizeFrame);
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      removeEventListener('resize', this.handleWindowResize);
      (0, _Timers.cancelSchedulerCallback)(this._resizeFrame);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          animateOnMount = _props.animateOnMount,
          animateOnToggle = _props.animateOnToggle,
          ariaExpanded = _props['aria-expanded'],
          ariaLabelledby = _props['aria-labelledby'],
          arrowColor = _props.arrowColor,
          arrowSize = _props.arrowSize,
          autoPlacement = _props.autoPlacement,
          Button = _props.Button,
          buttonRef = _props.buttonRef,
          buttonSize = _props.buttonSize,
          buttonText = _props.buttonText,
          buttonUse = _props.buttonUse,
          caretRenderer = _props.caretRenderer,
          __children = _props.children,
          className = _props.className,
          closeOnOutsideClick = _props.closeOnOutsideClick,
          closeOnTargetLeave = _props.closeOnTargetLeave,
          __Content = _props.Content,
          __dropdownClassName = _props.dropdownClassName,
          __dropdownContentRef = _props.dropdownContentRef,
          iconName = _props.iconName,
          id = _props.id,
          __locked = _props.locked,
          __menuWidth = _props.menuWidth,
          __minMenuWidth = _props.minMenuWidth,
          multiline = _props.multiline,
          onChangePlacement = _props.onChangePlacement,
          __onClick = _props.onClick,
          onFocusLeave = _props.onFocusLeave,
          onOpenChange = _props.onOpenChange,
          onOpenComplete = _props.onOpenComplete,
          onOpenStart = _props.onOpenStart,
          open = _props.open,
          pinToConstraint = _props.pinToConstraint,
          placement = _props.placement,
          popoverRef = _props.popoverRef,
          popoverProps = _props.popoverProps,
          readOnly = _props.readOnly,
          __shouldCloseOnClick = _props.shouldCloseOnClick,
          _useNativeButton = _props._useNativeButton,
          rest = _objectWithoutProperties(_props, ['animateOnMount', 'animateOnToggle', 'aria-expanded', 'aria-labelledby', 'arrowColor', 'arrowSize', 'autoPlacement', 'Button', 'buttonRef', 'buttonSize', 'buttonText', 'buttonUse', 'caretRenderer', 'children', 'className', 'closeOnOutsideClick', 'closeOnTargetLeave', 'Content', 'dropdownClassName', 'dropdownContentRef', 'iconName', 'id', 'locked', 'menuWidth', 'minMenuWidth', 'multiline', 'onChangePlacement', 'onClick', 'onFocusLeave', 'onOpenChange', 'onOpenComplete', 'onOpenStart', 'open', 'pinToConstraint', 'placement', 'popoverRef', 'popoverProps', 'readOnly', 'shouldCloseOnClick', '_useNativeButton']);

      var computedArrowSize = arrowSize || getArrowSize(buttonUse);
      var computedButtonClassName = getButtonClassName(className, multiline, open, readOnly);
      var computedPlacement = getPlacement(placement, computedArrowSize);
      var computedDistanceAdjustment = getDistanceAdjustment(buttonSize, buttonUse);
      var computedInsetAdjustment = getInsetAdjustment(buttonUse, placement, computedArrowSize);
      var renderedButtonLabel = renderButtonLabel(buttonText, iconName, readOnly);
      var renderedCaret = CustomRenderer.render(caretRenderer, {
        use: buttonUse
      });

      var ButtonType = Button || (buttonUse === 'unstyled' ? _UIClickable2.default : _UIButton2.default);
      var buttonProps = buttonUse === 'unstyled' ? {} : {
        _useNativeButton: _useNativeButton,
        size: buttonSize,
        use: buttonUse
      };
      var buttonId = id || this._buttonId;

      // UIDatePicker: allow setting aria-expanded={true} when open={false}
      var computedAriaExpanded = !!(ariaExpanded != null ? ariaExpanded : open) || undefined;

      return _react2.default.createElement(
        _UIControlledPopover2.default,
        _extends({
          animateOnMount: animateOnMount,
          animateOnToggle: animateOnToggle,
          arrowColor: arrowColor,
          arrowSize: computedArrowSize,
          autoPlacement: autoPlacement,
          closeOnOutsideClick: closeOnOutsideClick,
          closeOnTargetLeave: closeOnTargetLeave,
          Content: this.renderContent,
          _distanceAdjustment: computedDistanceAdjustment,
          _insetAdjustment: computedInsetAdjustment,
          onFocusLeave: onFocusLeave,
          onChangePlacement: onChangePlacement,
          onOpenChange: onOpenChange,
          onOpenStart: onOpenStart,
          onOpenComplete: onOpenComplete,
          open: open,
          pinToConstraint: pinToConstraint,
          placement: computedPlacement,
          popoverRef: popoverRef || this.popoverRef,
          shouldCloseOnClick: this.shouldCloseOnClick
        }, popoverProps),
        _react2.default.createElement(
          ButtonType,
          _extends({}, rest, buttonProps, {
            'aria-expanded': computedAriaExpanded,
            'aria-haspopup': true,
            'aria-labelledby': ariaLabelledby ? ariaLabelledby + ' ' + buttonId : buttonId,
            'aria-owns': this._contentId,
            className: computedButtonClassName,
            'data-dropdown-open': open,
            id: buttonId,
            onClick: this.handleButtonClick,
            onKeyDown: this.handleKeyDown,
            buttonRef: buttonRef
          }),
          _react2.default.createElement(
            'span',
            { className: 'uiDropdown__buttonContents private-dropdown__button__contents' },
            renderedButtonLabel,
            !readOnly && renderedCaret
          )
        )
      );
    }
  }]);

  return UIAbstractDropdown;
}(_react.Component);

UIAbstractDropdown.propTypes = {
  animateOnMount: _propTypes2.default.bool.isRequired,
  animateOnToggle: _propTypes2.default.bool,
  'aria-expanded': (0, _decorators.hidden)(_propTypes2.default.bool),
  'aria-labelledby': _propTypes2.default.string,
  arrowColor: _propTypes2.default.string,
  arrowSize: _propTypes2.default.oneOf(Object.keys(_UIPopoverArrow2.default.ARROW_SIZES)),
  autoPlacement: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.oneOf(['horiz', 'vert'])]).isRequired,
  Button: _propTypes2.default.elementType,
  buttonRef: _refObject2.default.isRequired,
  buttonSize: _UIButton2.default.propTypes.size,
  buttonText: _propTypes2.default.node,
  buttonUse: _UIDropdownCaret2.default.propTypes.use,
  caretRenderer: CustomRenderer.propType,
  children: _propTypes2.default.node,
  closeOnOutsideClick: _propTypes2.default.bool,
  closeOnTargetLeave: _propTypes2.default.bool,
  Content: _propTypes2.default.elementType,
  disabled: _propTypes2.default.bool,
  dropdownClassName: _propTypes2.default.string,
  dropdownContentRef: (0, _decorators.hidden)(_propTypes2.default.func),
  iconName: (0, _iconName.getIconNamePropType)(),
  locked: _propTypes2.default.bool.isRequired,
  menuWidth: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.oneOf(['auto'])]),
  minMenuWidth: _propTypes2.default.number.isRequired,
  multiline: (0, _decorators.hidden)(_propTypes2.default.bool.isRequired),
  onChangePlacement: _propTypes2.default.func,
  onFocusLeave: _propTypes2.default.func,
  onOpenChange: _propTypes2.default.func,
  onOpenComplete: _propTypes2.default.func,
  onOpenStart: _propTypes2.default.func,
  open: _propTypes2.default.bool.isRequired,
  pinToConstraint: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.arrayOf(_propTypes2.default.oneOf(_PlacementConstants.PLACEMENTS_SIDES))]),
  placement: _propTypes2.default.oneOf(_PlacementConstants.PLACEMENTS),
  popoverRef: _refObject2.default,
  popoverProps: _propTypes2.default.object,
  readOnly: _propTypes2.default.bool,
  shouldCloseOnClick: _propTypes2.default.func,
  _useNativeButton: _propTypes2.default.bool
};

UIAbstractDropdown.defaultProps = {
  animateOnMount: false,
  autoPlacement: 'vert',
  buttonSize: 'default',
  buttonUse: 'secondary',
  caretRenderer: _react2.default.createElement(_UIDropdownCaret2.default, null),
  closeOnOutsideClick: true,
  dropdownClassName: '',
  locked: false,
  minMenuWidth: _Tether.MIN_MENU_WIDTH,
  multiline: false,
  open: false
};

UIAbstractDropdown.displayName = 'UIAbstractDropdown';

exports.default = (0, _ShareButton2.default)(UIAbstractDropdown);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.3620/js/dropdown/abstract/UIAbstractDropdown.js
// module id = 198
// module chunks = 177